import React from "react";
import { useNavigate } from "react-router-dom";
import GroupsGBP from "../features/groups/GroupsGBP";

const GroupsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
       <GroupsGBP
      onNavigateToGBP={(id: number) => navigate(`/gbp?accountId=${id}`)}
      onNavigateHome={() => navigate("/accueil")}
    />
  );
};

export default GroupsPage;